import React, { useEffect, useRef, useState } from 'react'
import { Button, Form, Modal, OverlayTrigger, Popover } from 'react-bootstrap'

import { lblAddress, lblEmail, lblFirstName, lblLastName, lblPhoneNumber, txtMainInfo, txtMobileNumber, txtSearchAddress } from '../../dataBaseFile/label';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import InputField from '../../jsx/components/fields/inputField';
import {  validEmail_OR_MobileNumberText, validFirstName, validMobileNumberText } from "../../dataBaseFile/error";
import { emailValidation, localTimeCommonFunction, minLengthValidation, phoneOnChange, phoneValidation } from '../../functions/validations';
import PrimaryButton from '../../jsx/components/button/primaryButton';

import ResponceToaster from '../../jsx/components/responceToaster/responceToaster';
import EmailPhoneCombine from '../../jsx/components/fields/emailPhoneField';
import {  numberOnChangeOnlyInteger } from '../../validations/validation';
import { getGuestUserLinkApi } from '../../service/api/user/getGuestUserLink';
import { createUpdateGuestLinkApi } from '../../service/api/user/createUpdateGuestUserLink';
import { set } from 'date-fns';
import PhonenumberField from '../../jsx/components/fields/phoneFields';
const CreateUpdateLink = ({ guestLinkModalStatus, handleClose, modalType, guestId }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

   
 
    const [email, setEmail] = useState("")
    const [phonenumber, setPhonenumber] = useState('');
    const [isPhoneError, setIsPhoneError] = useState(false);
    const [countryCode, setCountryCode] = useState(1);
    const [isEmailError, setIsEmailError] = useState(false);
    const [loaderActive, setLoaderActive] = useState(false)
    const [handleToaster, setHandleToaster] = useState(false);
    const [toasterType, setToasterType] = useState();
    const [resMessage, setResMessage] = useState("");
    const [accessLimit, setAccessLimit] = useState("")
    const [accessLimitErr, setAccessLimitErr] = useState(false)
    const [expirationDate,setExpirationDate] = useState(localTimeCommonFunction().split('T')[0])
    const [expirationUnix,setExpirationUnix] = useState(0)
   const[guestToken,setGuestToken] = useState("")
    useEffect(() => {

        if (modalType != "CREATE") {
            var data ={
                guest_user_login_link_id:guestId,
               
            }
           dispatch(
             getGuestUserLinkApi(data, (res) => {
              const data = res.data?.data[0]
              setEmail(data?.email_chr)
              console.log(data?.phone_number_int)
              setPhonenumber(data?.phone_number_int)
              setCountryCode(data?.phone_code_id_lng)
              setAccessLimit(data?.number_of_times_link_can_be_accessed)
              setExpirationDate(new Date(data?.link_expiration_time  * 1000).toISOString().split("T")[0])
              setGuestToken(data?.guest_user_token_chr)
             }, (err) => {
             })
           );
        }
    }, [])


  


    function handleAccessLimit(e) {
            if(numberOnChangeOnlyInteger(e.target.value) || e.target.value == ""){
                setAccessLimitErr(false)
                setAccessLimit(e.target.value)
                
            }  
       
         
    }

    const handleOnBlurAccessLimit = () => {
       if(accessLimit == 0 || accessLimit.length == ""){
           setAccessLimitErr(true)
       }
    }

    function handleEmailBlurCheck() {
            if (emailValidation(email)) {
                setIsEmailError(false)
            } else {
                setIsEmailError(true)
            }
    }
    function handleEmail(e) {
            setEmail(e.target.value)
            setIsEmailError(false)
    }

    function handlePhonenumberBlurCheck() {
        if (modalType == "UPDATE" || modalType == "CREATE") {
            if (!phoneValidation(phonenumber) && phonenumber !== '') {
                setIsPhoneError(true);
            }
        }
    }
    const handlePhonenumber = (e) => {
        if (modalType == "UPDATE" || modalType == "CREATE") {
            setIsPhoneError(false);

            phoneOnChange(e.target.value) && setPhonenumber(e.target.value);
        }
        setIsEmailError(false);
    };
    const handleCountryCode = (e) => {
            setCountryCode(e);
    };
    function generateGuestUserToken() {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let token = '';
        for (let i = 0; i < 16; i++) {
            token += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return token;
    }
    function getBaseURL() {
        const url = window.location.href; // Get the full URL from the browser
        const match = url.match(/^(https?:\/\/[^\/]+\.com)/);
        return match ? match[1] : null;
    }
    function handleSubmit() {


        if (modalType == "CREATE") {
            
            if (!emailValidation(email)) {
                setIsEmailError(true);
                return
            }
            if ( !phoneValidation(phonenumber) && phonenumber !== '') {
                setIsPhoneError(true);
                return
            }
            if(accessLimit == 0 || accessLimit.length == ""){
                setAccessLimitErr(true)
                return
            }
            setLoaderActive(true)
const token = generateGuestUserToken()
            const data ={
                action :"CREATE",
                email_chr:email,
                phone_code_id_int:countryCode,
                phone_number_int:phonenumber === "" ? 0 : phonenumber,
                number_of_times_link_can_be_accessed:accessLimit,
                link_expiration_time:expirationUnix,
                guest_user_token_chr :token,
                guest_user_link_chr : `${getBaseURL()}/login?valid=${token}`

            
             
            }

            dispatch(createUpdateGuestLinkApi(data,(res) => {
                setLoaderActive(false)
                setResMessage(res.data.message);
                                setToasterType("success");
                                setHandleToaster(true);
                                setTimeout(() => {
                                    setHandleToaster(false);
                                }, 11000);
            },(err) => {
                setToasterType("error");
                            setHandleToaster(true)
                            setResMessage(err.data.message);
                            setLoaderActive(false)

                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);
            }))



           

           
        }




      



        if (modalType == "UPDATE") {

           
            if(accessLimit == 0 || accessLimit.length == ""){
                setAccessLimitErr(true)
                return
            }
            setLoaderActive(true)
            const data ={
                action :"UPDATE",
                email_chr:email,
                guest_user_login_link_id:guestId,
                phone_code_id_int:countryCode,
                phone_number_int:phonenumber === "" ? 0 : phonenumber,
                number_of_times_link_can_be_accessed:accessLimit,
                link_expiration_time:expirationUnix,
                guest_user_token_chr :guestToken,
                // guest_user_link_chr : `https://dev-app.chilll.com/login?valid=${guestToken}`

                guest_user_link_chr : `${getBaseURL()}/login?valid=${guestToken}`

            
             
            }
            dispatch(createUpdateGuestLinkApi(data,(res) => {
                setLoaderActive(false)
                setResMessage(res.data.message);
                                setToasterType("success");
                                setHandleToaster(true);
                                setTimeout(() => {
                                    setHandleToaster(false);
                                }, 11000);
            },(err) => {
                setToasterType("error");
                            setHandleToaster(true)
                            setResMessage(err.data.message);
                            setLoaderActive(false)

                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);
            }))


           

        }

    }
   

   


    








  

  
    const handleChangeExpirationDate = (e) => {

        const inputDate = e?.target?.value;

        if (!inputDate) return;
        const unixTimestamp = inputDate ? Math.floor(new Date(inputDate).getTime() / 1000) : '';

        // console.log(unixTimestamp);
        setExpirationDate(inputDate);
        setExpirationUnix(unixTimestamp);
    }
    useEffect(() => {
        const unixTimestamp = expirationDate ? Math.floor(new Date(expirationDate).getTime() / 1000) : '';
        setExpirationUnix(unixTimestamp);
    },[expirationDate])
    return (
        <>
            {/* <!-- Modal --> */}
            <Modal className="fade" size={"md"} show={guestLinkModalStatus}
                // onHide={handleClose}
                centered
            >
              


                <Modal.Body>

                    <div className='row mx-0'>
                        <div className='col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black'>
                            <span onClick={() => handleClose()} className='cursor-pointer'>
                                <i className="bi bi-x-lg"></i>
                            </span>
                        </div>
                    </div>

                    <div className='row mx-0 mb-2'>
                        <div className='fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black'>
                            <span className=''>
                                {modalType == "UPDATE" && "Edit guest link"}
                                {modalType == "CREATE" && "Create guest link"}
                            </span>
                        </div>
                    </div>

                   



                 

                        <div className='mt-2' style={{ borderRadius: '5px', padding: '5px 0px', marginBottom: '10px' }}>
                         
                            



                            <InputField
                                labelName={"Email"}
                                placeholderName={"Email"}
                                onChange={handleEmail}
                                onBlur={handleEmailBlurCheck}
                                errorOccured={isEmailError}
                                errorMeesage={validEmail_OR_MobileNumberText}
                                value={email}
                                isRequired={true}
                                autoF={modalType == "CREATE" ? true : false}
                                disabled={modalType == "UPDATE" ? true : false}
                            />
{modalType == "CREATE" ?
 <div className='mt-1'>
 <EmailPhoneCombine
     inputValue={phonenumber}
     handleInputValue={handlePhonenumber}
     errorOccured={isPhoneError}
     errorMessage={validMobileNumberText}
     handleChangeCode={handleCountryCode}
     handleOnBlur={handlePhonenumberBlurCheck}
     isEnteringNumber={true}
     defaultCodeValue={countryCode}
     label={txtMobileNumber}
     disabled={modalType == "UPDATE" ? true : false}
 />
</div> : <div className='mt-1'>
<InputField
                                labelName={"Phone number"}
                                placeholderName={"Email"}
                                
                                value={phonenumber}
                                isRequired={true}
                                autoActivated={true}
                                disabled={modalType == "UPDATE" ? true : false}
                            />
                            </div>
}
                           
                            <InputField
                                labelName={"Access limit"}
                                placeholderName={"Access limit"}
                                onChange={handleAccessLimit}
                                onBlur={() => { handleOnBlurAccessLimit() }}
                                errorOccured={accessLimitErr}
                                errorMeesage={"Please enter valid AccessLimit"}
                                value={accessLimit}
                                maxLength={10}
                                autoActivated={true}
                            />
   
                          
   <div className='col-12 px-0'>
                                                                                <InputField
                                                                                    type='date'
                                                                                    labelName={"Expiration  date"}
                                                                                    placeholder={"Expiration date"}
                                                                                    value={expirationDate}
                                                                                    onChange={handleChangeExpirationDate}
                                                                                    errorOccured={false}
                                                                                    errorMeesage={"Please enter link expiration date"}
                                                                                    autoActivated={true}
                                                                                />
                                                                            </div>

                        </div>




                    {modalType != "view" && <div className="d-flex align-items-center justify-content-end">
                        <PrimaryButton
                            onClick={handleSubmit}
                            buttonName={modalType == "CREATE" ? "CREATE LINK" : "EDIT LINK"}
                            isLoading={loaderActive}
                            loadingMessage={modalType == "CREATE" ? "CREATING" : "UPDATING"}
                            style={{
                                width: '100%',
                                border: 'none',
                                background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                            }}
                        />
                    </div>}






                </Modal.Body>

            </Modal >

            {handleToaster && (
                <ResponceToaster toasterType={toasterType} message={resMessage} />
            )}
        </>
    )
}

export default CreateUpdateLink